import { get } from 'lodash';

import { REVIEWS_CHANNEL, WEBSITE_CHANNEL } from 'src/data/channel';
import { ADS_CHANNELS } from 'src/data/performance';
import { ROUTES } from 'src/routes';

const ADS_CHANNEL_VIEWS = ADS_CHANNELS.reduce((a, v) => ({ ...a, [v]: v }), {});

export const PAGE_VIEW = {
  website: 'website',
  reviews: 'reviews',
  ads: 'ads',
  talkingPoints: 'talking-points',
  customScoringModels: 'custom-scoring-models',
  performanceData: 'data',
};

export const PAGE_VIEW_PROPS = {
  [PAGE_VIEW.performanceData]: {
    label: 'Connected Channels',
  },
  [PAGE_VIEW.website]: {
    label: 'Connected Channels',
  },
  [PAGE_VIEW.reviews]: {
    label: 'Connected Channels',
  },
  [PAGE_VIEW.ads]: {
    label: 'Connected Channels',
  },
  [PAGE_VIEW.talkingPoints]: {
    label: 'High Performing Talking Points',
  },
  [PAGE_VIEW.customScoringModels]: {
    label: 'Custom Scoring Models',
  },
};

export const CHANNEL_VIEW = {
  ...ADS_CHANNEL_VIEWS,
  ...REVIEWS_CHANNEL,
  ...WEBSITE_CHANNEL,
};

export const getViewLabel = (channel) => get(PAGE_VIEW_PROPS, [channel, 'label']) || '';

export const FILTER_LABEL_TEXT_WIDTH = 46;

export const TABLE = { copy: 'copy', talkingPoints: 'talkingPoints', campaigns: 'campaigns' };

export const getTablesForView = (view) => {
  const tables = Object.values(TABLE);
  if (view === PAGE_VIEW.website) {
    return tables;
  } else if (view === PAGE_VIEW.reviews) {
    return tables.filter((t) => t === TABLE.talkingPoints);
  } else {
    return tables.filter((t) => t !== TABLE.campaigns);
  }
};

const TABLE_PROPS = {
  [TABLE.copy]: {
    label: {
      [PAGE_VIEW.ads]: 'Ad Copy',
      [PAGE_VIEW.reviews]: 'Reviews',
      default: 'Copy',
    },
  },
  [TABLE.talkingPoints]: {
    label: { default: 'High Performing Talking Points' },
  },
  [TABLE.campaigns]: {
    label: { default: 'Campaigns' },
  },
};

export const getTableLabel = (table, view) =>
  TABLE_PROPS[table].label[view] || TABLE_PROPS[table].label.default;

export const getViewRoute = (view) => {
  switch (view) {
    case PAGE_VIEW.ads:
      return ROUTES.PERFORMANCE_ADS;

    case PAGE_VIEW.reviews:
      return ROUTES.PERFORMANCE_REVIEWS;

    default:
      return null;
  }
};

export const getDefaultViewChannel = (view) => {
  switch (view) {
    case PAGE_VIEW.ads:
      return ADS_CHANNELS[0];

    case PAGE_VIEW.reviews:
      return REVIEWS_CHANNEL.trustpilot;

    default:
      return null;
  }
};

export const getClickableLink = (link) =>
  link.startsWith('http://') || link.startsWith('https://') ? link : `http://${link}`;

export const PAGE_HEADER_HEIGHT = 54;
export const CHANNEL_HEADER_HEIGHT = 64;
export const ZENDESK_HEIGHT = 76;
export const TABLE_PAGINATION_HEIGHT = 55;
export const BLOCK_ACTIONS_HEIGHT = 93;
